import { CdkAriaLive } from '@angular/cdk/a11y';
import { Injectable } from '@angular/core';
import { ExportService } from './export.service';
@Injectable({
  providedIn: 'root'
})

export class PdfService extends ExportService {

  pdfMake: any = null;
  dataUrl = null

  private async loadPdfMaker() {

    if (this.pdfMake !== null)
      return;

    const pdfMakeModule = await import('pdfmake/build/pdfmake');
    const pdfFontsModule = await import('pdfmake/build/vfs_fonts');
    this.pdfMake = pdfMakeModule.default;
    this.pdfMake.vfs = pdfFontsModule.default.pdfMake.vfs;

  }

  public async generateTable<T>(
    data: Array<T>,
    {
      title = "",
      pageSize = "A4",
      pageOrientation = "portrait",
      fontSize = 10,
      headerRows = 1,
      aliasColumns = {},
      dateColumns = {},
      showColumns = [],
      widths = []
    } = {}, imagenGrafico?) {

    await this.loadPdfMaker();

    let table = {
      headerRows: headerRows,
      widths,
      body: this.convertJSONToTable<T>(data, { aliasColumns, dateColumns, showColumns })
    };

    if (!table.body.length)
      throw ("la tabla no puede estar vacía.")

    if (!widths.length)
      table.widths = table.body[0].map(() => "auto");

    let def = {
      pageSize,
      pageOrientation,
      defaultStyle: {
        fontSize
      },
      content: [
        { text: title, fontSize: fontSize + 2, bold: true },
        {
          table
        }
      ]
    };
    if (imagenGrafico) {
      (def.content as any).push(
        { text: "\nGráfico de informe", fontSize: fontSize + 2, bold: true },
        { image: imagenGrafico })
    }

    this.pdfMake.createPdf(def).open();
  }

  public async generateEnvelope({
    cliente, direccion, localidad, provincia, cp
  }) {
    if (!cliente)
      return

    await this.loadPdfMaker();

    let docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 60, 120, 120],

      content: ([
        {
          text: ['Atte. ', { text: cliente, bold: true }]
        }, {
          text: '\n' + '   ' + direccion + `\n   ` + localidad + `\n   ` + provincia + `\n   ` + cp,
          absolutePosition: { x: 70, y: 60 }
        },
        {
          text: ['Rtte. ',
            { text: 'GRIFFOULIERE & ASOCIADOS S.A.', bold: true },
          ],
          widths: [100, 100, 100],
          relativePosition: {
            x: 310,
            y: 670,
          }
        },
        {
          text: `\nAv. San Martin 941 Piso 9 Oficina 1\nCiudad - (5500)\nMendoza`,
          relativePosition: { x: 340, y: 670 }
        }
      ])
    };

    this.pdfMake.createPdf(docDefinition).open();
  }

  public async generateSpreadsheet<T>(
    data: Array<T>,
    {
      codigoFondo = null,
      grupoEconomico = null,
      numeroRendicion = null,
      anio = null,
      mes = null,
      fechaActual = null,
      total = null,
      dateColumns = {},
      showColumns = [],
      aliasColumns = {},
      widths = []
    }) {
    await this.loadPdfMaker();

    let table = {
      headerRows: 1,
      widths,
      body: this.convertJSONToTable<T>(data, { aliasColumns, dateColumns, showColumns })
    };

    if (!table.body.length)
      throw ("la tabla no puede estar vacía.")

    if (!widths.length)
      table.widths = table.body[0].map(() => "auto");

    let docDefinition = {
      pageSize: 'A4',

      content: ([
        {
          image: 'data:image/png;base64,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',
          width: 70,
          relativePosition: { x: 50, y: 0 }
        },
        {
          text: 'Mendoza:',
          decoration: 'underline',
          absolutePosition: { x: 415, y: 90 }
        },
        {
          text: fechaActual,
          decoration: 'underline',
          absolutePosition: { x: 485, y: 90 }
        },
        {
          bold: true,
          alignment: 'center',
          text: [`${codigoFondo} - ${grupoEconomico}\n`,
          { text: `RENDICIÓN N°:       ${numeroRendicion} / ${anio}\n`, bold: false },
            'GASTOS REALIZADOS POR CUENTA Y ORDEN'],
          relativePosition: { x: 0, y: 80 }
        },
        
        {
          alignment: 'center',
          table,
          relativePosition: { x: 0, y: 130 }
        },
        {
          style: 'tableExample',
          color: '#444',
          table: {
            widths: [150, 170, 150],
            heights: [10, 50, 10],
            headerRows: 1,
            body: [
              [
                { text: 'Estudio', border: [false, true, false, false], fontSize: 10, alignment: 'center' },
                { text: '', border: [false, false, false, false] },
                { text: 'Responsable a Cargo', border: [false, true, false, false], fontSize: 10, alignment: 'center' }
              ]
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return 'black';
            },
            vLineColor: function (i, node) {
              return 'black';
            },
            hLineStyle: function (i, node) {
              return { dash: { length: 4 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 4 } };
            },
          },
          relativePosition: { x: 10, y: 600 }
        },
        {
          style: 'tableExample',
          color: '#444',
          table: {
            widths: [150, 170, 150],
            heights: [10, 50, 10],
            headerRows: 1,
            body: [
              [
                { text: '', border: [false, false, false, false] },
                { text: 'Responsable de la empresa', border: [false, true, false, false], fontSize: 10, alignment: 'center' },
                { text: '', border: [false, false, false, false] }
              ]
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return 'black';
            },
            vLineColor: function (i, node) {
              return 'black';
            },
            hLineStyle: function (i, node) {
              return { dash: { length: 4 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 4 } };
            },
          },
          relativePosition: { x: 10, y: 700 }
        }
      ])
    };

    this.pdfMake.createPdf(docDefinition).open();
  }
}
